import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_4457c266 from 'nuxt_plugin_head_4457c266' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_47be0c52 from 'nuxt_plugin_plugin0_47be0c52' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_47bd2394 from 'nuxt_plugin_plugin1_47bd2394' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_47bc3ad6 from 'nuxt_plugin_plugin2_47bc3ad6' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_47bb5218 from 'nuxt_plugin_plugin3_47bb5218' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_47ba695a from 'nuxt_plugin_plugin4_47ba695a' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_47b9809c from 'nuxt_plugin_plugin5_47b9809c' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_47b897de from 'nuxt_plugin_plugin6_47b897de' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_47b7af20 from 'nuxt_plugin_plugin7_47b7af20' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_47b6c662 from 'nuxt_plugin_plugin8_47b6c662' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_47b5dda4 from 'nuxt_plugin_plugin9_47b5dda4' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_afe74130 from 'nuxt_plugin_plugin10_afe74130' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_afe65872 from 'nuxt_plugin_plugin11_afe65872' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_afe56fb4 from 'nuxt_plugin_plugin12_afe56fb4' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_afe486f6 from 'nuxt_plugin_plugin13_afe486f6' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_afe39e38 from 'nuxt_plugin_plugin14_afe39e38' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_afe2b57a from 'nuxt_plugin_plugin15_afe2b57a' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_afe1ccbc from 'nuxt_plugin_plugin16_afe1ccbc' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_afe0e3fe from 'nuxt_plugin_plugin17_afe0e3fe' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_afdffb40 from 'nuxt_plugin_plugin18_afdffb40' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_afdf1282 from 'nuxt_plugin_plugin19_afdf1282' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_afcb122e from 'nuxt_plugin_plugin20_afcb122e' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_afca2970 from 'nuxt_plugin_plugin21_afca2970' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_afc940b2 from 'nuxt_plugin_plugin22_afc940b2' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_afc857f4 from 'nuxt_plugin_plugin23_afc857f4' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_afc76f36 from 'nuxt_plugin_plugin24_afc76f36' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_4457c266 === 'function') {
    await nuxt_plugin_head_4457c266(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_47be0c52 === 'function') {
    await nuxt_plugin_plugin0_47be0c52(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_47bd2394 === 'function') {
    await nuxt_plugin_plugin1_47bd2394(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_47bc3ad6 === 'function') {
    await nuxt_plugin_plugin2_47bc3ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_47bb5218 === 'function') {
    await nuxt_plugin_plugin3_47bb5218(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_47ba695a === 'function') {
    await nuxt_plugin_plugin4_47ba695a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_47b9809c === 'function') {
    await nuxt_plugin_plugin5_47b9809c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_47b897de === 'function') {
    await nuxt_plugin_plugin6_47b897de(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_47b7af20 === 'function') {
    await nuxt_plugin_plugin7_47b7af20(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_47b6c662 === 'function') {
    await nuxt_plugin_plugin8_47b6c662(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_47b5dda4 === 'function') {
    await nuxt_plugin_plugin9_47b5dda4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_afe74130 === 'function') {
    await nuxt_plugin_plugin10_afe74130(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_afe65872 === 'function') {
    await nuxt_plugin_plugin11_afe65872(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_afe56fb4 === 'function') {
    await nuxt_plugin_plugin12_afe56fb4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_afe486f6 === 'function') {
    await nuxt_plugin_plugin13_afe486f6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_afe39e38 === 'function') {
    await nuxt_plugin_plugin14_afe39e38(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_afe2b57a === 'function') {
    await nuxt_plugin_plugin15_afe2b57a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_afe1ccbc === 'function') {
    await nuxt_plugin_plugin16_afe1ccbc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_afe0e3fe === 'function') {
    await nuxt_plugin_plugin17_afe0e3fe(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_afdffb40 === 'function') {
    await nuxt_plugin_plugin18_afdffb40(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_afdf1282 === 'function') {
    await nuxt_plugin_plugin19_afdf1282(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_afcb122e === 'function') {
    await nuxt_plugin_plugin20_afcb122e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_afca2970 === 'function') {
    await nuxt_plugin_plugin21_afca2970(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_afc940b2 === 'function') {
    await nuxt_plugin_plugin22_afc940b2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_afc857f4 === 'function') {
    await nuxt_plugin_plugin23_afc857f4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_afc76f36 === 'function') {
    await nuxt_plugin_plugin24_afc76f36(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
